export enum ReturnStatus {
    OPEN = "OPEN",
    PEND = "PEND",
    CLSD = "CLSD",
    CNCL = "CNCL",
    FULL = "FULL",
    RCNC = "RCNC",
    NEW = "NEW",
    PRTL = "PRTL",
    PROC = "PROC",
    POST = "POST",
    NA = "NA",
}
